import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import Configuration from "./components/Configuration";
import MasterDashboard from "./components/MasterDashboard";
import SystemDashboard from "./components/SystemDashboard";
import Reports from "./components/Reports";
import SignInPage from "./components/SignIn";
import Logs from "./components/Logs";
import SystemLogs from "./components/SystemLogs";
import AddCustomer from "./components/AddCustomer";
import AddLicense from "./components/AddLicense";
import { DashboardProvider } from "./contexts/DashboardContext";
import QueryEditor from "./components/QueryEditor";
import Documentation from "./components/Documentation";
import UpdateLicense from "./components/UpdateLicense";
import Compliance from "./components/Compliance";
import AddNewRule from "./components/AddNewRule";
import ManageRuleFiles from "./components/ManageRulesFiles";
import RuleContent from "./components/RuleContent";
import AddNewDecoder from "./components/AddNewDecoder";
import DecoderContent from "./components/DecoderContent";
import ManageDecoderFiles from "./components/ManageDecodersFiles";
import EditRule from "./components/EditRule";
import EditDecoder from "./components/EditDecoder";

function App() {
  return (
    <DashboardProvider>
      <div className="App">
        <Router>
          <Routes>
            <Route path="/" exact element={<LandingPage />} />
            <Route path="/configuration" element={<Configuration />} />
            <Route path="/dashboard" element={<MasterDashboard />} />
            <Route path="/systemdashboard" element={<SystemDashboard />} />
            <Route
              path="/systemdashboard/:agent"
              element={<SystemDashboard />}
            />
            <Route path="/reports" element={<Reports />} />
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/logs/systems/:group" element={<Logs />} />
            <Route
              path="/logs/node/:node/:group/:timeframe"
              element={<SystemLogs />}
            />
            <Route path="/addcustomer" element={<AddCustomer />} />
            <Route path="/addlicense" element={<AddLicense />} />
            <Route path="/console" element={<QueryEditor />} />
            <Route path="/documentation" element={<Documentation />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/updatelicense" element={<UpdateLicense />} />
            <Route path="/managerules" element={<ManageRuleFiles />} />
            <Route path="/managedecoders" element={<ManageDecoderFiles />} />
            <Route path="/addnewrule" element={<AddNewRule />} />
            <Route path="/addnewdecoder" element={<AddNewDecoder />} />
            <Route path="/rule/:filename" element={<RuleContent />} />
            <Route path="/rule/edit/:filename" element={<EditRule />} />
            <Route path="/decoder/:filename" element={<DecoderContent />} />
            <Route path="/decoder/edit/:filename" element={<EditDecoder />} />
          </Routes>
        </Router>
      </div>
    </DashboardProvider>
  );
}

export default App;
